import { render, staticRenderFns } from "./RequestResetPasswordForm.vue?vue&type=template&id=5852d4dc&"
import script from "./RequestResetPasswordForm.vue?vue&type=script&lang=ts&"
export * from "./RequestResetPasswordForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports